import { render, staticRenderFns } from "./index.vue?vue&type=template&id=52490a27&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=52490a27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52490a27",
  null
  
)

export default component.exports